import Rest from '../Rest'

export default class TeacherService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/teachers'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

  // Bank Details
  saveBankDetail(id: Number, payload: any) {
    return this.post(`/${id}/bank_details`, payload).then(data => {
      return data
    })
  }

  deleteBankDetail(id: Number, bankDetailId: Number) {
    return this.delete(`/${id}/bank_details/${bankDetailId}`).then(data => {
      return data
    })
  }

  getAllBankDetails(id: Number) {
    return this.get(`/${id}/bank_details`).then(data => {
      return data
    })
  }
  //----

  //---Modalities
  attachModalities(id: Number, payload: any) {
    return this.post(`/${id}/modalities`, {ids: payload}).then(data => {
      return data
    })
  }

  deleteModality(id: Number, modalityId: Number) {
    return this.delete(`/${id}/modalities/${modalityId}`).then(data => {
      return data
    })
  }

  getAllModalities(id: Number) {
    return this.get(`/${id}/modalities`).then(data => {
      return data
    })
  }
  //----
  // Class Entities
  saveClassEntity(id: Number, payload: any) {
    return this.post(`/${id}/class_entities`, payload).then(data => {
      return data
    })
  }

  deleteClassEntity(id: Number, entityId: Number) {
    return this.delete(`/${id}/class_entities/${entityId}`).then(data => {
      return data
    })
  }

  getAllClassEntities(id: Number) {
    return this.get(`/${id}/class_entities`).then(data => {
      return data
    })
  }

  // ---
  deleteImage(id, mediaId) {
    return this.delete(`/${id}/images/${mediaId}`).then(
      (response) => {
        return response
      }
    )
  }
}
